import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root'
})
export class DeviceOrderService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  list(pageNumber: number = 1, searchValue: string = '', dateFrom: string = '', dateTo: string = '') {

    let params = 'page=' + pageNumber + '&search=' + searchValue;
    if (dateFrom !== '' && dateTo !== '') {
      params += '&from=' + dateFrom + '&to=' + dateTo;
    }

    return this.http.get<any>(`${environment.apiUrl}/admin/device_requests/list?${params}`)
      .pipe(map(response => {
        if (response && response.token) {
          this.authService.setNewToken(response.token);
          this.authService.setUserData(response.user);
        }
        return response;
      }));
  }

  update(id: number, status: string) {
    return this.http.post<any>(`${environment.apiUrl}/admin/device_requests/update`, {
        request_id: id,
        status: `${status}`
      })
      .pipe(map(response => {
        if (response && response.token) {
          this.authService.setNewToken(response.token);
          this.authService.setUserData(response.user);
        }
        return response;
      }));

  }

}
